import type { SVGProps } from 'react';

const SvgPlayerFlipHorizontally = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M21.5 11.5c0-.55-.45-1-1-1h-16c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1m-3-5v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-1.65-1.35-3-3-3h-10c-1.65 0-3 1.35-3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1m0 9.04v1.99s0 .97 1 .97 1-1 1-1v-1.96c0-.55-.45-1-1-1s-1 .45-1 1m-12 1.96v-1.95c0-.55-.45-1-1-1s-1 .45-1 1v2.05c.02.54.47.94 1.02.93.55 0 .98-.49.98-1.04zm11.04 2c0-.55-.45-1-1-1h-2.02c-.55 0-1 .45-1 1s.45 1 1 1h2.02c.55 0 1-.45 1-1m-6.05 0c0-.55-.45-1-1-1H8.47c-.55 0-1 .45-1 1s.45 1 1 1h2.02c.55 0 1-.45 1-1"
    />
  </svg>
);
export default SvgPlayerFlipHorizontally;
